/* eslint-disable react-hooks/exhaustive-deps */
import AppText from "components/AppText";
import SelectDropdown from "components/SelectDropdown";
import { sweetAlert, updateUserDataAndChatbot } from "functions/global";
import {
  getFbPages,
  getInstaAccs,
  getPageAccessToken,
} from "pages/FbManagerAccess/functions";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import store from "store";

const FbPages = ({ accessToken }: { accessToken: string }) => {
  const { userData = {} } = useSelector((state: any) => state.appReducer) as {
    userData: any;
  };

  const [fbPages, setFbPages] = React.useState<any>([]);
  const [fbPagesLoading, setFbPagesLoading] = React.useState(false);
  const [selectedFbPage, setSelectedFbPage] = React.useState<any>(
    userData?.lastSelectedFbPage || null
  );
  const [igPagesLoading, setIgPagesLoading] = React.useState(false);
  const [igPages, setIgPages] = React.useState<any>([]);
  const [selectedIgPage, setSelectedIgPage] = React.useState<any>(
    userData?.lastSelectedInstaAcc || null
  );

  const fetchFbPages = async () => {
    try {
      setFbPagesLoading(true);
      const { userData = {} }: any = store.getState().appReducer;
      const { lastSelectedWorkspace = {} } = userData;
      const { workspaceId } = lastSelectedWorkspace;

      const fbPages: any = await getFbPages(accessToken, workspaceId, true);
      console.log(fbPages, "filteredPages");
      setFbPages([...fbPages]);
    } catch (e) {
    } finally {
      setFbPagesLoading(false);
    }
  };

  const _getInstaAccs = async (
    selectedFbPage: any,
    lastSelectedInstaAcc?: any
  ) => {
    setIgPagesLoading(true);
    try {
      const pageAccesstoken = await getPageAccessToken(selectedFbPage?.id);
      if (pageAccesstoken) {
        selectedFbPage.access_token = pageAccesstoken;
        const instaAccounts: any = await getInstaAccs(selectedFbPage);

        if (instaAccounts?.length) {
          setIgPages([...instaAccounts]);
          if (lastSelectedInstaAcc) {
            const instaAcc = instaAccounts?.find(
              (insta: any) => insta?.id === lastSelectedInstaAcc?.id
            );
            setSelectedIgPage(instaAcc);
            updateUserDataAndChatbot("lastSelectedInstaAcc", instaAcc);
          } else if (instaAccounts?.length === 1) {
            setSelectedIgPage(instaAccounts[0]);
            updateUserDataAndChatbot("lastSelectedInstaAcc", instaAccounts[0]);
          }
          return instaAccounts;
        } else {
          setIgPages([]);
          // setAdvertiseInsta(false);
        }
      }
    } catch (error) {
      console.log(error, "error");
      sweetAlert(
        "Something went wrong while fetching your Instagram pages. please try again"
      );
    } finally {
      setIgPagesLoading(false);
    }
  };

  useEffect(() => {
    fetchFbPages();
  }, [accessToken]);

  useEffect(() => {
    if (selectedFbPage?.id) {
      _getInstaAccs(selectedFbPage, selectedIgPage);
    }
  }, [selectedFbPage?.id]);

  const onChangePage = (value: any) => {
    setSelectedFbPage(value);
    updateUserDataAndChatbot("lastSelectedFbPage", value);
  };

  const onChangeInstaAcc = (value: any) => {
    setSelectedIgPage(value);
    updateUserDataAndChatbot("lastSelectedInstaAcc", value);
  };

  // render fb pages

  const _renderFbPage = () => {
    return fbPagesLoading ? (
      <p className="fb-manager-access-insta-loading-text">
        <AppText>loading facebook pages</AppText>
      </p>
    ) : (
      <>
        <div className="fb-page-selection-container">
          <img
            src="images/global/facebook.png"
            alt="fb-icon"
            style={{ height: "20px" }}
          />
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#2B3674",
              margin: "0px",
              marginLeft: "5px",
            }}
          >
            Facebook
          </p>
        </div>
        <SelectDropdown
          label="Please select your Facebook page"
          data={fbPages}
          value={selectedFbPage}
          onChange={(value: any) => onChangePage(value)}
          formatOptionLabel={(data: any) => (
            <div className="fb-option-row">
              <img
                className="ads-platform-page-icon"
                src={data?.picture?.data?.url}
                alt="page-logo"
              />
              <div>
                <span className="fb-option-name">{data?.name}</span>
                <p className="fb-option-id">Page Id: {data?.id}</p>
              </div>
            </div>
          )}
          getOptionLabel={
            (option: any) => option?.name //option?.username
          }
          getOptionValue={(option: any) => option?.id}
          labelClassname={"fb-page-selection-label"}
        />
      </>
    );
  };

  const _renderInstaPages = () => {
    return igPagesLoading ? (
      <p className="fb-manager-access-insta-loading-text">
        <AppText>loading Instagram account</AppText>
      </p>
    ) : (
      <div style={{ marginTop: "30px" }}>
        <div className="fb-page-selection-container">
          <img
            src="images/global/instagram.png"
            alt="fb-icon"
            style={{ height: "20px" }}
          />
          <p
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "#2B3674",
              margin: "0px",
              marginLeft: "5px",
            }}
          >
            Instagram
          </p>
        </div>

        <SelectDropdown
          label="Please select your Instagram account"
          data={igPages}
          value={selectedIgPage}
          onChange={(value: any) => onChangeInstaAcc(value)}
          formatOptionLabel={(data: any) => (
            <div>
              <img
                className="ads-platform-page-icon"
                src={data?.profile_pic}
                alt="page-logo"
              />
              <span>{data?.username}</span>
            </div>
          )}
          getOptionLabel={
            (option: any) => option?.username //option?.username
          }
          getOptionValue={(option: any) => option?.id}
          labelClassname={"fb-page-selection-label"}
        />
      </div>
    );
  };

  return (
    <div className="fb-pages-container">
      {_renderFbPage()}
      {selectedFbPage?.id && _renderInstaPages()}
    </div>
  );
};

export default React.memo(FbPages);
